export const APP_KEY_SEARCH = process.env.REACT_APP_KEY_SEARCH;
export const APP_ID_SEARCH = process.env.REACT_APP_ID_SEARCH;

export const APP_KEY_DATABASE = process.env.REACT_APP_KEY_DATABASE;
export const APP_ID_DATABASE = process.env.REACT_APP_ID_DATABASE;

export const APP_KEY_ANALYSIS = process.env.REACT_APP_KEY_ANALYSIS;
export const APP_ID_ANALYSIS = process.env.REACT_APP_ID_ANALYSIS;